<template>
    <div class="left-delete">
        <div class="move"
             @touchstart="_touchStart"
             @touchmove="_touchMove"
             @touchend="_touchEnd"
             :style="txtStyle">
            <slot></slot>
        </div>
        <!-- <mu-raised-button label="删除" class="deleteIcon" @click.prevent="deleteItem(index)" :style="zIndex"/> -->
        <div class="deleteIcon" :style="zIndex"  @click.prevent="deleteItem(index)"><span>删除</span></div>
    </div>
</template>

<script>
    export default {
    	props: {
            index: [Number,String]
        },
        data() {
            return {
                startX: 0,       //触摸位置
                moveX: 0,       //滑动时的位置
                disX: 0,       //移动距离
                txtStyle: '',
                delWidth: 150,
                top: '',
                zIndex: 'z-index:-1',
            }
        },
        methods: {
            _touchStart: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1){
                    // 手指按下的时候记录按下的位置
                    this.startX = ev.touches[0].clientX;
                    //console.log(this.startX)
                }
            },
            _touchMove: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1) {
                    // 滑动过程中的实时位置
                    this.moveX = ev.touches[0].clientX
                    // 滑动过程中实时计算滑动距离
                    this.disX = this.startX - this.moveX;
                    //console.log('disX==>',this.disX)
                    // 如果是向右滑动或者只是点击，不改变滑动位置
                    if(this.disX < 0 || this.disX == 0) {
                        // console.log('没有移动');
                        this.txtStyle = "transform:translateX(0rem)";
                         this.zIndex = "z-index:" + -1+ ";width:" + 0 + "rem";
                    }
                    else if (this.disX > 50) {
						//如果是向左滑动，则实时给这个根元素一个向左的偏移-left，当偏移量到达固定值delWidth时，固定元素的偏移量为 delWidth
                        this.txtStyle = "transform:translateX(-" + this.disX/100 + "rem)";
                        this.zIndex = "z-index:" + 10+ ";width:" + this.disX/100 + "rem";
                        // if (this.disX  >= this.delWidth/2) {
                        //     this.txtStyle = "transform:translateX(-" + this.delWidth/100 + "rem)";
                        //     this.zIndex = "z-index:" + 10 + ";width:" + this.delWidth/100 + "rem";
                        // }
                    }
                }
            },
            _touchEnd: function(ev) {
                if (event.changedTouches.length == 1) {
                    // 手指移动结束后的水平位置
                    let endX = event.changedTouches[0].clientX;
                    // 触摸开始与结束,手指移动的距离
                    this.disX = this.startX - endX;
                    //如果距离小于删除按钮的1/2，不显示删除按钮
                    //console.log("=>",this.disX )
                     //滑动结束，判断当前的滑动距离大于或等于时 偏移
                    if (this.disX >= this.delWidth/2) {
                        this.txtStyle = "transform:translateX(-" + this.delWidth/100 + "rem)";
                        this.zIndex = "z-index:" + 10 + ";width:" + this.delWidth/100 + "rem";
                    }
                    else{
                        this.txtStyle = "transform:translateX(-" + 0+ "rem)";
                        this.zIndex = "z-index:" + -1+ ";width:" + 0 + "rem";
                        
                    }
                }
            },
            deleteItem: function(index) {
                this.$emit('deleteItem', index);
            }
        }
    }
</script>

<style>
    .left-delete{
        width:100%;
        height:100%;
        position:relative;
        z-index:2;
        .mu-raised-button-label{
            padding: 0
        }
    }
    .move{
        position: relative;
        background: #fff;
    }
    .deleteIcon{
        border-radius: 0px;
    	font-size: 0.35rem;
        width: 1.5rem;
        /*min-width: 1.5rem;*/
        height: 100%;
        position: absolute;
        right:0;
        top:0;
        background:#E60012;
        text-align: center;
    	color: #fff;
        border-bottom: 1px solid #fff;
        box-shadow: 0 0px 0px rgba(0,0,0,.117647), 0 1px 4px rgba(0,0,0,.117647);
        
    }
    .deleteIcon span{
            top: 50%;
            position: absolute;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
        }
    .mu-raised-button.deleteIcon  .mu-raised-button-label{
            padding: 0
        }
</style>


// WEBPACK FOOTER //
// touchDelete.vue?c7c46278